// extracted by mini-css-extract-plugin
module.exports =  {"salesPerformance":"salesPerformance__gMTzF","exportBtn":"exportBtn__hWBje","tips":"tips__9KWp-","tableAction":"tableAction__3xWgC"};